(function () {
  "use strict";

  var countryLabels = {
    "Germany": "Deutschland",
    "The Netherlands": "Niederlande",
    "Netherlands": "Niederlande",
    "Belgium": "Belgien",
    "Austria": "Österreich",
    "Switzerland": "Schweiz",
    "Luxembourg": "Luxemburg",
    "France": "Frankreich",
    "Italy": "Italien",
    "Denmark": "Dänemark"
  };

  var mobileMediaQuery = window.matchMedia("(max-width: 990px)");

  function normalizePlain(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/ß/g, "ss")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, " und ")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizeGerman(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, " und ")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function compact(value) {
    return normalizePlain(value).replace(/[^a-z0-9]/g, "");
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function encode(value) {
    return encodeURIComponent(String(value || ""));
  }

  function getCountryLabel(country, fallback) {
    return countryLabels[country] || fallback || country || "Sonstige";
  }

  function getStreetLine(store) {
    return store.street_line || [store.street, store.house_number].filter(Boolean).join(" ");
  }

  function getAddressLine(store) {
    var streetLine = getStreetLine(store);
    var cityLine = [store.zip, store.city].filter(Boolean).join(" ");
    var countryLine = getCountryLabel(store.country, store.country_label);

    return [streetLine, cityLine, countryLine].filter(Boolean).join(", ");
  }

  function getMapsQuery(store) {
    return store.maps_query || [store.name, getAddressLine(store)].filter(Boolean).join(", ");
  }

  function getMapQuery(store) {
    return store.map_query || getAddressLine(store) || getMapsQuery(store);
  }

  function getMapsSearchUrl(store) {
    return "https://www.google.com/maps/search/?api=1&query=" + encode(getMapsQuery(store));
  }

  function getDirectionsUrl(store) {
    return "https://www.google.com/maps/dir/?api=1&destination=" + encode(getMapQuery(store));
  }

  function getMapEmbedUrl(store) {
    return "https://maps.google.com/maps?hl=de&z=16&q=" + encode(getMapQuery(store)) + "&output=embed";
  }

  function buildIndex(store) {
    var values = [
      store.name,
      store.type,
      store.street,
      store.house_number,
      store.street_line,
      store.zip,
      store.city,
      store.country,
      store.country_label,
      getCountryLabel(store.country, store.country_label),
      store.region,
      store.language,
      store.address,
      store.map_query,
      store.maps_query
    ].join(" ");

    store._index = [
      normalizePlain(values),
      normalizeGerman(values)
    ].join(" ");

    store._compactIndex = [
      compact(values),
      compact(store.zip),
      compact(store.city),
      compact(getAddressLine(store))
    ].join(" ");

    store._countryLabel = getCountryLabel(store.country, store.country_label);
    store._addressLine = getAddressLine(store);

    return store;
  }

  function uniqueValues(values) {
    return values.reduce(function (acc, value) {
      if (value && acc.indexOf(value) === -1) acc.push(value);
      return acc;
    }, []);
  }

  function getQueryTokenGroups(value) {
    var raw = String(value || "").trim();
    if (!raw) return [];

    return raw
      .split(/[\s,;|/\\]+/)
      .map(function (token) {
        return uniqueValues([
          normalizePlain(token),
          normalizeGerman(token),
          compact(token)
        ]);
      })
      .filter(function (variants) {
        return variants.length > 0;
      });
  }

  function matchesQuery(store, query) {
    var tokenGroups = getQueryTokenGroups(query);
    if (!tokenGroups.length) return true;

    return tokenGroups.every(function (variants) {
      return variants.some(function (token) {
        var compactToken = token.replace(/[^a-z0-9]/g, "");
        return store._index.indexOf(token) > -1 ||
          (compactToken && store._compactIndex.indexOf(compactToken) > -1);
      });
    });
  }

  function sortStores(stores) {
    return stores.slice().sort(function (a, b) {
      return String(a.city || "").localeCompare(String(b.city || ""), "de", { sensitivity: "base" }) ||
        String(a.zip || "").localeCompare(String(b.zip || ""), "de", { sensitivity: "base" }) ||
        String(a.name || "").localeCompare(String(b.name || ""), "de", { sensitivity: "base" });
    });
  }

  function buildCard(store, isActive) {
    var dataQuality = Array.isArray(store.data_quality) ? store.data_quality : [];
    var warningHtml = dataQuality.length
      ? '<p class="zs-storefinder__warning">Adresse bitte vor Besuch kurz über Google Maps oder beim Händler prüfen.</p>'
      : "";

    return [
      '<article class="zs-storefinder__card' + (isActive ? " is-active" : "") + '" data-store-id="' + escapeHtml(store.id) + '" tabindex="0" role="button" aria-pressed="' + (isActive ? "true" : "false") + '" aria-label="' + escapeHtml(store.name) + ' auf der Karte anzeigen">',
        '<div class="zs-storefinder__card-top">',
          '<h3 class="zs-storefinder__store-name">' + escapeHtml(store.name) + '</h3>',
          '<span class="zs-storefinder__tag">' + escapeHtml(store.type || "Partner Store") + '</span>',
        '</div>',
        '<p class="zs-storefinder__address">' + escapeHtml(getStreetLine(store)) + '<br>' + escapeHtml([store.zip, store.city].filter(Boolean).join(" ")) + '<br>' + escapeHtml(store._countryLabel) + '</p>',
        '<p class="zs-storefinder__note">' + escapeHtml(store.note || "Sortiment und Verfügbarkeit können je Standort variieren.") + '</p>',
        warningHtml,
        '<p class="zs-storefinder__tap-hint">Antippen öffnet die Karte für diesen Händler.</p>',
        '<div class="zs-storefinder__actions">',
          '<a class="zs-storefinder__link zs-storefinder__link--primary" href="' + getDirectionsUrl(store) + '" target="_blank" rel="noopener">Route planen</a>',
          '<a class="zs-storefinder__link" href="' + getMapsSearchUrl(store) + '" target="_blank" rel="noopener">In Maps öffnen</a>',
        '</div>',
      '</article>'
    ].join("");
  }

  function initStorefinder(root) {
    var rawStores = Array.isArray(window.ZUITABLE_STORES) ? window.ZUITABLE_STORES : [];
    var stores = rawStores.map(buildIndex);

    var searchInput = root.querySelector("[data-zs-store-search]");
    var countrySelect = root.querySelector("[data-zs-store-country]");
    var resetButton = root.querySelector("[data-zs-store-reset]");
    var countElement = root.querySelector("[data-zs-store-count]");
    var listElement = root.querySelector("[data-zs-store-list]");
    var mapElement = root.querySelector("[data-zs-store-map]");
    var selectedNameElement = root.querySelector("[data-zs-selected-name]");
    var selectedAddressElement = root.querySelector("[data-zs-selected-address]");
    var selectedNoticeElement = root.querySelector("[data-zs-selected-notice]");
    var selectedDirectionsElement = root.querySelector("[data-zs-selected-directions]");
    var selectedMapsElement = root.querySelector("[data-zs-selected-maps]");
    var mapWrap = root.querySelector("[data-zs-map-wrap]");
    var listPanel = root.querySelector("[data-zs-list-panel]");
    var viewButtons = root.querySelectorAll("[data-zs-view-button]");
    var viewListButton = root.querySelector("[data-zs-view-list]");

    var filteredStores = sortStores(stores);
    var activeId = filteredStores[0] ? filteredStores[0].id : null;
    var mobileView = "list";
    var mapChangeToken = 0;

    function isMobile() {
      return mobileMediaQuery.matches;
    }

    function scrollToElement(element) {
      if (!element || !isMobile()) return;

      window.setTimeout(function () {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }

    function setMobileView(view, shouldScroll) {
      mobileView = view === "map" ? "map" : "list";
      root.setAttribute("data-mobile-view", mobileView);

      viewButtons.forEach(function (button) {
        var isActive = button.getAttribute("data-zs-view-button") === mobileView;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      if (shouldScroll) {
        scrollToElement(mobileView === "map" ? mapWrap : listPanel);
      }
    }

    function populateCountryFilter() {
      if (!countrySelect) return;

      var countries = stores.reduce(function (acc, store) {
        var country = store.country || store.country_label || "";
        if (country && acc.indexOf(country) === -1) acc.push(country);
        return acc;
      }, []).sort(function (a, b) {
        return getCountryLabel(a).localeCompare(getCountryLabel(b), "de", { sensitivity: "base" });
      });

      countrySelect.innerHTML = '<option value="">Alle Länder</option>' + countries.map(function (country) {
        return '<option value="' + escapeHtml(country) + '">' + escapeHtml(getCountryLabel(country)) + '</option>';
      }).join("");
    }

    function getStoreById(storeId) {
      return stores.find(function (store) {
        return store.id === storeId;
      }) || null;
    }

    function getActiveStore() {
      return filteredStores.find(function (store) {
        return store.id === activeId;
      }) || filteredStores[0] || null;
    }

    function updateSelectedLinks(store) {
      var hasStore = !!store;
      var directionsUrl = hasStore ? getDirectionsUrl(store) : "#";
      var mapsUrl = hasStore ? getMapsSearchUrl(store) : "#";

      if (selectedDirectionsElement) {
        selectedDirectionsElement.setAttribute("href", directionsUrl);
        selectedDirectionsElement.classList.toggle("is-disabled", !hasStore);
        selectedDirectionsElement.setAttribute("aria-disabled", hasStore ? "false" : "true");
      }

      if (selectedMapsElement) {
        selectedMapsElement.setAttribute("href", mapsUrl);
        selectedMapsElement.classList.toggle("is-disabled", !hasStore);
        selectedMapsElement.setAttribute("aria-disabled", hasStore ? "false" : "true");
      }
    }

    function updateSelectedInfo(store) {
      if (!store) {
        if (selectedNameElement) selectedNameElement.textContent = "Kein Händler ausgewählt";
        if (selectedAddressElement) selectedAddressElement.textContent = "Bitte Suche anpassen.";
        if (selectedNoticeElement) selectedNoticeElement.textContent = "";
        updateSelectedLinks(null);
        return;
      }

      if (selectedNameElement) {
        selectedNameElement.textContent = store.name || "Ausgewählter Händler";
      }

      if (selectedAddressElement) {
        selectedAddressElement.textContent = store._addressLine || getAddressLine(store);
      }

      if (selectedNoticeElement) {
        selectedNoticeElement.textContent = store.note || "Sortiment und Verfügbarkeit können je Standort variieren.";
      }

      updateSelectedLinks(store);
    }

    function updateMap(store) {
      if (!mapElement || !store) {
        updateSelectedInfo(null);
        return;
      }

      var url = getMapEmbedUrl(store);
      var title = "Karte: " + (store.name || "Zuitable Händler");

      updateSelectedInfo(store);

      mapChangeToken += 1;
      var token = mapChangeToken;

      if (mapWrap) {
        mapWrap.classList.add("is-loading");
      }

      mapElement.setAttribute("title", title);

      /*
       * Resetting the iframe first prevents Google Maps from keeping the old
       * embedded result when only the query string changes.
       */
      mapElement.setAttribute("src", "about:blank");

      window.setTimeout(function () {
        if (token !== mapChangeToken) return;

        mapElement.setAttribute("src", url);
        mapElement.setAttribute("data-current-store-id", store.id);
        mapElement.setAttribute("data-current-map-url", url);
      }, 40);
    }

    function updateActiveCards() {
      if (!listElement) return;

      var cards = listElement.querySelectorAll("[data-store-id]");
      cards.forEach(function (card) {
        var isActive = card.getAttribute("data-store-id") === activeId;
        card.classList.toggle("is-active", isActive);
        card.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    function applyFilters() {
      var query = searchInput ? searchInput.value : "";
      var selectedCountry = countrySelect ? countrySelect.value : "";

      filteredStores = sortStores(stores.filter(function (store) {
        var matchesText = matchesQuery(store, query);
        var matchesCountry = !selectedCountry || store.country === selectedCountry || store.country_label === selectedCountry;
        return matchesText && matchesCountry;
      }));

      if (!filteredStores.some(function (store) { return store.id === activeId; })) {
        activeId = filteredStores[0] ? filteredStores[0].id : null;
      }
    }

    function renderList() {
      if (countElement) {
        countElement.textContent = filteredStores.length === 1
          ? "1 Händler gefunden"
          : filteredStores.length + " Händler gefunden";
      }

      if (!listElement) return;

      if (!filteredStores.length) {
        listElement.innerHTML = [
          '<div class="zs-storefinder__empty">',
            '<strong>Keine Händler gefunden.</strong>',
            '<span>Bitte suche nach einer anderen Stadt, PLZ oder einem anderen Händlernamen.</span>',
          '</div>'
        ].join("");

        if (mapElement) {
          mapElement.setAttribute("src", "about:blank");
        }

        updateSelectedInfo(null);
        return;
      }

      listElement.innerHTML = filteredStores.map(function (store) {
        return buildCard(store, store.id === activeId);
      }).join("");

      updateActiveCards();
    }

    function render(options) {
      var keepView = options && options.keepView;

      applyFilters();
      renderList();
      updateMap(getActiveStore());

      if (!keepView && isMobile()) {
        setMobileView("list", false);
      }
    }

    function selectStore(storeId, options) {
      var store = getStoreById(storeId);
      if (!store) return;

      activeId = storeId;
      updateActiveCards();
      updateMap(store);

      if (isMobile()) {
        setMobileView("map", true);
      } else if (options && options.scrollMap) {
        scrollToElement(mapWrap);
      }
    }

    populateCountryFilter();
    setMobileView("list", false);
    render({ keepView: true });

    if (mapElement) {
      mapElement.addEventListener("load", function () {
        if (mapWrap && mapElement.getAttribute("src") !== "about:blank") {
          mapWrap.classList.remove("is-loading");
        }
      });
    }

    if (searchInput) {
      searchInput.addEventListener("input", function () {
        render({ keepView: false });
      });
    }

    if (countrySelect) {
      countrySelect.addEventListener("change", function () {
        render({ keepView: false });
      });
    }

    if (resetButton) {
      resetButton.addEventListener("click", function () {
        if (searchInput) searchInput.value = "";
        if (countrySelect) countrySelect.value = "";
        filteredStores = sortStores(stores);
        activeId = filteredStores[0] ? filteredStores[0].id : null;
        renderList();
        updateMap(getActiveStore());
        setMobileView("list", true);
        if (searchInput) searchInput.focus();
      });
    }

    viewButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var view = button.getAttribute("data-zs-view-button");
        setMobileView(view, true);
      });
    });

    if (viewListButton) {
      viewListButton.addEventListener("click", function () {
        setMobileView("list", true);
      });
    }

    if (listElement) {
      listElement.addEventListener("click", function (event) {
        var link = event.target.closest("a");
        if (link) return;

        var card = event.target.closest("[data-store-id]");
        if (!card) return;

        selectStore(card.getAttribute("data-store-id"));
      });

      listElement.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;

        var card = event.target.closest("[data-store-id]");
        if (!card) return;

        event.preventDefault();
        selectStore(card.getAttribute("data-store-id"));
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-zs-storefinder]").forEach(initStorefinder);
  });
})();